import Vue from 'vue'

export default function (bytes, precision, override) {
  const lang = Vue.i18n.locale() || 'en'

  if (!bytes) {
    if (lang === 'fr') return '0 o'
    if (lang === 'en') return '0 B'
  }
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
    return '-'
  }
  if (typeof precision === 'undefined') {
    precision = 1
  }
  const units = {
    en: [
      'B',
      'KB',
      'MB',
      'GB',
      'TB',
      'PB'
    ],
    fr: [
      'o',
      'Ko',
      'Mo',
      'Go',
      'To',
      'Po'
    ]
  }
  const number = Math.floor(Math.log(bytes) / Math.log(1024))
  const value = (bytes / Math.pow(1024, Math.floor(number)))
  override = (typeof override !== 'undefined' && (override - 1)) || 0
  const max = Math.pow(10, override)
  precision = precision || 0
  const digitNbr = precision ? value.toFixed(precision).length - 1 : value.toFixed(precision).length

  if (override && precision && (digitNbr > max.toString().length)) {
    precision = precision - (digitNbr - max.toString().length)
  }
  let unit = (units[lang] && units[lang][number]) || units.en[number]
  return `${value.toFixed(precision)} ${unit}`
}
